<template>
  <v-container fluid>
    <v-img v-if="backgroundVariant === 'image'" :src="backgroundUrl" lazy-src="/static/background.webp" cover height="100%" width="100%">
      <signinCard></signinCard>
    </v-img>
    <span v-else>
      <canvas ref="canvas"></canvas>
      <signinCard></signinCard>
    </span>
  </v-container>
</template>

<script>
  import signinCard from './SigninCard'
  export default {
    components: {
      signinCard
    },
    data () {
      return {
        email: '',
        password: '',
        showAbout: false,
        showLoginInfo: false,
        checkMailValue: { status: null },
        test: false,
        loading: false,
        logoUrl: null,
        backgroundUrl: null,
        canvas: {},
        ctx: null
      }
    },
    mounted () {
      this.loadBackground()
      this.loadLogo()
      this.initializeCanvas()
      this.drawCanvas()
      this.addEventListeners()
    },
    computed: {
      backgroundVariant () {
        return this.backgroundUrl ? 'image' : 'canvas1'
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          if (this.$route.query !== '') {
            this.$router.push(this.$route.query.link)
          } else {
            this.$router.push('/')
          }
        }
      }
    },
    methods: {
      addEventListeners () {
        window.addEventListener('resize', this.resizeCanvas)
      },
      resizeCanvas () {
        this.canvas.width = window.innerWidth
        this.canvas.height = window.innerHeight
        this.drawBackground()
        this.drawCanvas()
      },
      drawBackground () {
        this.ctx.fillStyle = '#E3F2FD'
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)
      },
      initializeCanvas () {
        this.canvas = this.$refs.canvas
        this.ctx = this.canvas.getContext('2d')
        this.resizeCanvas()
      },
      drawBadge (x, w, color) {
        this.ctx.save()

        this.ctx.beginPath()
        this.ctx.moveTo(0, x)
        this.ctx.lineTo(0, x + w)
        this.ctx.lineTo(x + w, 0)
        this.ctx.lineTo(x, 0)
        this.ctx.closePath()

        this.ctx.fillStyle = color
        this.ctx.shadowBlur = 10
        this.ctx.shadowColor = 'rgba(0, 0, 0, 0.1)'
        this.ctx.fill()

        this.ctx.restore()
      },
      drawTriangle (x1, y1, x2, y2, x3, y3, color) {
        this.ctx.save()

        this.ctx.beginPath()
        this.ctx.moveTo(x1, y1)
        this.ctx.lineTo(x2, y2)
        this.ctx.lineTo(x3, y3)
        this.ctx.closePath()

        this.ctx.fillStyle = color
        this.ctx.shadowBlur = 10
        this.ctx.shadowColor = 'rgba(0, 0, 0, 0.2)'
        this.ctx.fill()

        this.ctx.restore()
      },
      drawCircle (x, y, r, color) {
        this.ctx.save()

        this.ctx.beginPath()
        this.ctx.arc(x, y, r, 0, 2 * Math.PI)
        this.ctx.closePath()

        this.ctx.fillStyle = color
        this.ctx.shadowBlur = 20
        this.ctx.shadowColor = 'rgba(0, 0, 0, 0.3)'
        this.ctx.fill()

        this.ctx.restore()
      },
      drawCanvas () {
        const h = this.canvas.height
        // const w = this.canvas.width
        // this.drawTriangle(w, h, 0, h, w, -h, this.hexToRgba('#D5E1F5', 1))
        if (this.backgroundVariant === 'canvas1') {
          this.drawTriangle(0, 0, 0, h, h, 0, this.hexToRgba('#E3F2FD', 1))
          this.drawTriangle(0, 0.2 * h, 0, h, 0.8 * h, h, this.hexToRgba('#E3F2FD', 1))
          // this.drawBadge(145, 130, this.hexToRgba('#FFFFFF', 1))
          // this.drawBadge(150, 120, this.hexToRgba(this.$vuetify.theme.themes.light.secondary, 3))
          // this.drawBadge(150, 80, this.hexToRgba('#FFFFFF', 1))
          // this.drawBadge(150, 40, this.hexToRgba(this.$vuetify.theme.themes.light.primary, 1))
        }
        if (this.backgroundVariant === 'canvas2') {
          for (let i = 0; i < 10; i++) {
            const x = Math.random() * this.canvas.width
            const y = Math.random() * this.canvas.height
            const radius = Math.random() * 200 + 30
            const transparency = Math.random() * 0.3 + 0.2
            const color = this.hexToRgba(this.$vuetify.theme.themes.light.primary, transparency)
            this.drawCircle(x, y, radius, color)
          }
        }
      },
      hexToRgba (hex, alpha) {
        if (!/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
          throw new Error('Ungültiges Hex-Format für Farbe')
        }
        const [r, g, b] = hex.match(/\w{2}/g).map(value => parseInt(value, 16) * (hex.length === 4 ? 17 : 1))
        return `rgba(${r}, ${g}, ${b}, ${alpha})`
      },
      async loadLogo () {
        try {
          const url = await this.logoImage()
          this.logoUrl = url
        } catch (error) {
          console.error('Error loading logo:', error)
        }
      },
      async logoImage () {
        try {
          const storagePath = `/design/logo/${this.$vars.verbindung}`
          const url = await this.$firebase.storage().ref(storagePath).getDownloadURL()
          return url
        } catch (error) {
          console.error(error)
          throw error // Rethrow the error to be caught in the calling function
        }
      },
      async loadBackground () {
        try {
          const url = await this.backgroundImage()
          this.backgroundUrl = url
        } catch (error) {
          this.backgroundUrl = null
        }
      },
      async backgroundImage () {
        try {
          const storagePath = `/design/background/${this.$vars.verbindung}`
          const url = await this.$firebase.storage().ref(storagePath).getDownloadURL()
          return url
        } catch (error) {
          throw error // Rethrow the error to be caught in the calling function
        }
      },
      goToRegistrierung () {
        this.onDismissed()
        this.$router.push('/registrieren')
      },
      checkMail () {
        this.loading = true
        this.checkMailValue = { status: null }
        var functions = this.$firebase.functions()
        if (this.email) {
          functions.httpsCallable('userLoginAllowed')({ email: this.email.toLowerCase(), sub: this.$vars.verbindung })
            .then(({ data }) => {
              this.checkMailValue = data
              this.loading = false
            })
            .catch(error => {
              this.error = error
              this.loading = false
            })
        } else {
          this.checkMailValue = { status: null }
          this.loading = false
        }
      },
      onSignin () {
        this.test = true
        this.$store.dispatch('user/signUserIn', {email: this.email, password: this.password})
        this.$router.push('/')
      },
      onDismissed () {
        this.$store.dispatch('user/clearError')
      }
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeCanvas)
    }
  }
</script>

<style scoped>
/* body, html {
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
} */

canvas {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0; /* Stelle sicher, dass das Canvas hinter anderen Elementen liegt */
}


.backgroundimg {
  background-image: url('/static/ripuarenhaus.png');
  background-size: cover; /* Hier können Sie cover, contain oder andere Werte verwenden, um das Bild anzupassen */
  background-position: center center; /* Hier können Sie die Position des Hintergrundbilds anpassen */
  /* Weitere CSS-Stile nach Bedarf hinzufügen */
}
</style>

<!-- <v-sheet v-if="(showAbout || showLoginInfo)" height="100vh" width="400px" color="green" class="d-flex align-center justify-center mr-4">
  <v-card outlined class="pa-4 rounded-xl overflow-auto" height="80%">
    <v-card-title class="justify-space-between">
      <span v-if="showAbout">Was ist die Ripuaren-App?</span>
      <span v-if="showLoginInfo">Wie kann ich mich anmelden?</span>
      <v-btn icon @click="showAbout = false; showLoginInfo = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text v-if="showAbout">
      <v-alert class="px-0 pb-1">
        <template v-slot:prepend>
          <v-icon size="48" color="primary" class="mr-4">person_search</v-icon>
        </template>
        <div class="title">Bundesbrüder</div>
        <span class="subtitle-2 grey--text darken-4">Finde die Kontaktdaten Deiner Confüxe oder schau welche Bundesbrüder in der Deiner Nähe wohnen.</span>
      </v-alert>
      <v-alert class="px-0 pb-1">
        <template v-slot:prepend>
          <v-icon size="48" color="primary" class="mr-4">calendar_month</v-icon>
        </template>
        <div class="title">Veranstaltungen</div>
        <span class="subtitle-2 grey--text darken-4">Durchsuche das Semesterprogramm, melde Dich zu Veranstaltungen an und schau welche Bundesbrüder auch kommen.</span>
      </v-alert>
      <v-alert class="px-0 pb-1">
        <template v-slot:prepend>
          <v-icon size="48" color="primary" class="mr-4">badge</v-icon>
        </template>
        <div class="title">Kontaktdaten</div>
        <span class="subtitle-2 grey--text darken-4">Du bist umgezogen oder hast eine neue Telefonnummer? Änder Deine Daten einfach online.</span>
      </v-alert>
      <v-alert class="px-0 pb-1">
        <template v-slot:prepend>
          <v-icon size="48" color="primary" class="mr-4">account_tree</v-icon>
        </template>
        <div class="title">Stammbaum, Semesterrücblick, ...</div>
        <span class="subtitle-2 grey--text darken-4">Wie groß ist Deine Leibfamilie, wer war 2013 nochmal Charge? Durchsuche unsere Geschichte.</span>
      </v-alert>
      <v-alert class="px-0 pb-1">
        <template v-slot:prepend>
          <v-icon size="48" color="primary" class="mr-4">settings</v-icon>
        </template>
        <div class="title">Chargenaufgaben</div>
        <span class="subtitle-2 grey--text darken-4">Die Chargen, Vorstände und viele Wärte werden durch die Ripuaren-App mit unterschiedlichste Funktionen bei ihrer Arbeit unterstützt.</span>
      </v-alert>
    </v-card-text>
    <v-card-text v-if="showLoginInfo" class="pb-0">
      <v-alert class="px-0 pb-1">
        <template v-slot:prepend><v-icon size="48" color="primary" class="mr-4">looks_one</v-icon></template>
        <span class="subtitle-2 ">
          Registriere Dich mit der E-Mailadresse über die Du von Ripuaria E-Mails empfängst. Gehe dazu auf die Seite <a href="/registrieren">Registrieren</a> und gib deine Mailadresse ein.
          Deine E-Mailadresse wird direkt überprüft. Sollte diese im System hinterlegt sein, wird ein Haken hinter der Mailadresse angezeigt. Andernfalls bekommst du eine Fehlermeldung.
          Im Anschluss kannst du dir ein Passwort wählen. Dieses muss mindestens 6 Zeichen lang sein. Bestätige das Passwort, indem du es ein zweites Mal eingibst.
        </span>
      </v-alert>
      <v-alert class="px-0 pb-1">
        <template v-slot:prepend><v-icon size="48" color="primary" class="mr-4">looks_two</v-icon></template>
        <span class="subtitle-2 ">
          Im Anschluss bekommst du automatisch eine Mail zugeschickt. Aktiviere deinen Account über den Link in der Bestätigungsmail. Solltest du keine Bestätigungsmail erhalten haben, kannst du dir eine neue Mail zusenden lassen. Schau bitte auch in deinem SPAM-Ordner nach.
        </span>
      </v-alert>
      <v-alert class="px-0 pb-1">
        <template v-slot:prepend><v-icon size="48" color="primary" class="mr-4">looks_3</v-icon></template>
        <span class="subtitle-2 ">
          Fertig, Du kannst dich anmelden!
        </span>
      </v-alert>
    </v-card-text>
    <v-card-text v-if="showLoginInfo" class="pt-0 text-center">
      <span class="subtitle-2 text-center">
        Solltest Du weiterhin Probleme bei der Anmeldung haben, kontaktiere mich gerne:
        <br>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" href="https://wa.me/491634445098" target="_blank"><v-icon>mdi-whatsapp</v-icon></v-btn>
          </template>
          <span>Whatsapp</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" href="mailto:breuerbe@gmail.com" target="_blank"><v-icon>mail</v-icon></v-btn>
          </template>
          <span>Mail</span>
        </v-tooltip>
      </span>
    </v-card-text>
  </v-card>
</v-sheet>   -->



// WEBPACK FOOTER //
// Signin.vue?b6e2610c